import { ChrLdProvider } from '@chr/common-launchdarkly';
import { UserProfileContext } from '@chr/navisphereonline-shared-components';
import React from 'react';
import { AppConfig } from 'react-app-env';

export interface OnlineLDProviderProps {
  config: AppConfig;
}

export const OnlineLDProvider = (props: React.PropsWithChildren<OnlineLDProviderProps>) => {
  return (
    <UserProfileContext.Consumer>
      {(userProfile) => (
        <ChrLdProvider 
        envKey={props.config.launchDarklyClientId ?? ''} 
        context={{
            kind: 'user',
            key: userProfile.userId?.toString() ?? 'anonymous',
        }}
        options={{bootstrap: "localStorage"}}>
          {props.children}
        </ChrLdProvider>
      )}
    </UserProfileContext.Consumer>
  );
};
